module.exports = __webpack_public_path__ + "img/intro-birthday.2cc76fab.png";